import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux"

import store from "mx_pcb_assembly/store/store"
import App from "mx_pcb_assembly/App";
import Cart from "mx_pcb_assembly/cart/Cart";

document.addEventListener("DOMContentLoaded", () => {
  var appContainer = document.getElementById("quote-form");
  var cartContainer = document.getElementById("cart-form");

  if (appContainer != null) {
    render(
      <Provider store={store}>
        <App />
      </Provider>,
      appContainer
    );
  }

  if (cartContainer) {
    render(
      <Provider store={store}>
        <Cart />
      </Provider>,
      cartContainer
    );
  }
});
